import { render } from "./DockerRunNginx.vue?vue&type=template&id=235bdf02"
import script from "./DockerRunNginx.vue?vue&type=script&lang=js"
export * from "./DockerRunNginx.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__